import { API_DOMAIN } from "../../constants/api";
import axiosClient from "../axiosClient";

class ApiSip {
    getPeopleSearch() {
        return axiosClient.get(API_DOMAIN + 'sip/contacts')
    }

    insertPeopleSearch(name, domain) {
        return axiosClient.post(API_DOMAIN + 'sip/contacts', {name, domain})
    }

    getPeopleSearchPermission() {
        return axiosClient.get(API_DOMAIN + 'sip/contacts-permission')
    }

    getPeopleSearchOld() {
        return axiosClient.get(API_DOMAIN + 'peoplesearch')
    }

    getCalledRoom(addresses) {
        return axiosClient.post(API_DOMAIN + 'sip/called-room', { addresses });
    }

    resolveCalledRoom(sipUser, roomName) {
        return axiosClient.post(API_DOMAIN + 'sip/called-room', {
            sipUser,
            roomName
        });
    }
}

const apiSip = new ApiSip();

export default apiSip;
